import { UAParser } from 'ua-parser-js';

export const osDetector = async (): Promise<{
    name: string | undefined;
    version: string | undefined;
}> => {
    const userAgentParser = new UAParser();

    const uaOS = await userAgentParser.getOS().withClientHints();

    return {
        name: uaOS.name,
        version: oldWindowsVersionDetector() || uaOS.version,
    };
};

// we have to use custom detector for windows because ua-parser-js does not support detecting old versions of windows
const oldWindowsVersionDetector = () => {
    if (navigator.appVersion.includes('Windows NT 6.3')) {
        return '8.1';
    } else if (navigator.appVersion.includes('Windows NT 6.2')) {
        return '8';
    } else if (navigator.appVersion.includes('Windows NT 6.1')) {
        return '7';
    } else {
        return undefined;
    }
};
